var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-with-footer',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('page-header',{staticClass:"default-gutter"}),_c('global-search-bar',{staticClass:"default-gutter mt-6 mb-10",on:{"selected":_vm.selected}}),_c('landing-welcome'),_c('landing-cards',{staticClass:"default-gutter"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }